import { NgModule, Type } from '@angular/core';
import { AngleProcessingNamePipe } from './angle-processing-name.pipe';

import { CuttingOrderStatusActionNamePipe } from './cutting-order-statis-action-name.pipe';
import { DefaultCuttingOrderStatusNamePipe } from './default-cutting-order-status-name.pipe';
import { FileSizePipe } from './file-size.pipe';
import { TimeAgoPipe } from './time-ago.pipe';
import { WithLoadingPipe } from './with-loading.pipe';
import { ServiceNamePipe } from './service-name.pipe';
import { PurchaseStatePipe } from './purchase-state.pipe';
import { FinancialFlowStatusPipe } from './financial-flow-status.pipe';
import { PaymentSystemTypePipe } from './payment-system-type.pipe';

const PIPES: Type<any>[] = [
  DefaultCuttingOrderStatusNamePipe,
  CuttingOrderStatusActionNamePipe,
  WithLoadingPipe,
  TimeAgoPipe,
  AngleProcessingNamePipe,
  FileSizePipe,
  ServiceNamePipe,
  PurchaseStatePipe,
  FinancialFlowStatusPipe,
  PaymentSystemTypePipe,
];

@NgModule({
  imports: [],
  declarations: [PIPES],
  exports: [PIPES],
})
export class PipesModule {}
